import { useTranslation } from 'react-i18next';
import { useScrollReveal } from 'shared/hooks/useScrollReveal';

export const StorySection = () => {
  const { t } = useTranslation('about');
  const image = useScrollReveal({ animation: 'fade-image' });
  const heading = useScrollReveal({ animation: 'float-up', delay: 0 });
  const p1 = useScrollReveal({ animation: 'float-up', delay: 120 });
  const p2 = useScrollReveal({ animation: 'float-up', delay: 240 });
  // const p3 = useScrollReveal({ animation: 'float-up', delay: 360 });

  return (
    <section className="bg-surface-container-lowest py-12 mb-16 md:py-24 md:mb-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-24 items-center">
          <div ref={image.ref} style={image.style} className="order-2 md:order-1">
            <div className="aspect-square rounded-full overflow-hidden border-[12px] border-surface-container bg-surface-container-high">
              <img
                src="/images/mimosas.jpg"
                alt={t('story.imageAlt')}
                className="w-full h-full object-cover"
              />
            </div>
          </div>
          <div className="order-1 md:order-2">
            <h2 ref={heading.ref} style={heading.style} className="font-serif text-4xl mb-8">
              {t('story.heading', { podcastTitle: t('common:podcast.title') })}
            </h2>
            <div className="space-y-6 text-on-surface-variant font-sans leading-relaxed text-lg">
              <p ref={p1.ref} style={p1.style}>{t('story.paragraph1')}</p>
              <p ref={p2.ref} style={p2.style}>{t('story.paragraph2')}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
